<template>
  <Container type="card-full" drankColor>
    <div class="main">
      <div v-if="(+project.projectisqcheck === 1 && +project.projectqcheckflg === 1) || +project.projectisqcheck === 2">
        <el-tabs v-model="activeName" type="card" :before-leave="leaveTab">
          <el-tab-pane label="按评分项对比评分" name="apfxdb">
            <ex-expert-scoring-index :activeName="activeName"></ex-expert-scoring-index>
          </el-tab-pane>
          <el-tab-pane lazy label="按供应商逐一评分" name="agyszy">
            <ex-expert-scoring-com-index :activeName="activeName"></ex-expert-scoring-com-index>
          </el-tab-pane>
          <el-tab-pane lazy label="评分汇总" name="pfhz"  v-if="+this.$store.getters.expertLoginUser.pexpertroletype === 1">
            <ex-expert-score-summary :activeName="activeName"></ex-expert-score-summary>
          </el-tab-pane>
          <el-tab-pane lazy label="申请修改" name="sqgf">
            <ex-apply-for-modification :activeName="activeName" :pexchangetype="2"></ex-apply-for-modification>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div v-else class="alertmsg">
        项目初审检查未完成，完成后才可以评分!
      </div>
    </div>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import ExExpertScoringIndex from './exExpertScoringIndex'
  import ExExpertScoringComIndex from './exExpertScoringComIndex'
  import ExExpertScoreSummary from './exExpertScoreSummary'
  import exApplyForModification from './exApplyForModification'
  import utils from '../../assets/js/utils'
  import dayjs from 'dayjs'
  export default {
    name: 'exExpertScoringTab',
    data () {
      return {
        activeName: 'apfxdb',
        project: {},
        pexpertInfo:{},
      }
    },
    deactivated () {
      this.$destroy()
    },
    async created () {
      await this.getModel()
      await this.getModel()
      await this.getPexertInfo()
    },
    async activated() {
    },
    mounted () {
    },
    watch: {
    },
    components: {ExExpertScoringIndex, ExExpertScoringComIndex,ExExpertScoreSummary,exApplyForModification},
    methods: {
      async initData () {
        await request({
          url: 'expert/initPgsu',
          method: "post",
          data: {
            projectid: this.$store.getters.expertLoginUser.pexpertprojectid,
            pexpertid: this.$store.getters.expertLoginUser.pexpertid,
            projectpgstotalrule: this.project.projectpgstotalrule
          }
        })
      },
      leaveTab(activeName, oldActiveName) {
        if (+this.project.projectisqcheck === 1 && +this.project.projectqcheckflg !== 1) {
          return new Promise((resolve, reject)=> {
            this.$message.warning('项目初审检查未完成，完成后才可以评分!')
          })
          return
        }
      },
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.$store.getters.expertLoginUser.pexpertprojectid}
        })
        this.project = res
        if (+this.project.projectisqcheck === 1 && +this.project.projectqcheckflg !== 1) {
          this.$message.warning('项目初审检查未完成，完成后才可以评分!')
          return
        }
        // this.initData()
      },
      async getPexertInfo () {
        let res = await request({
          method: 'get',
          url: 'expert/getPexertInfo',
          params: {pexpertid: this.$store.getters.expertLoginUser.pexpertid}
        })
        this.pexpertInfo = res
        if(this.pexpertInfo.pexpertmobile == null){
            this.$message.warning('请先填写评审人资料')
            this.$router.push({name: 'pExpertIndex', params: {}})
            return
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .main {
    background-color: #fff;
    padding: 10px;
    .alertmsg {
      color: red;
      font-size: 14px;
    }
  }
</style>
